import { Component, OnInit } from '@angular/core';
import {
  ActivatedRoute,
  Event,
  NavigationEnd,
  Router,
  UrlSegment
} from '@angular/router';
import { SharedService } from 'app/shared.service';
import { ModalComponent } from '../modal/modal.component';
import { CheckoutService } from './checkout.service';

@Component({
  selector: 'app-checkout',
  templateUrl: './checkout.component.html',
  styleUrls: ['./checkout.component.scss']
})
export class CheckoutComponent implements OnInit {
  public isLoggedIn: boolean = false;
  public isConfirmation: boolean = false;

  constructor(
    private checkoutService: CheckoutService,
    private sharedService: SharedService,
    private router: Router
  ) {}

  ngOnInit() {
    this.isConfirmation = this.router.url === '/bestellen/bestaetigung';

    this.router.events.subscribe((event: Event) => {
      if (event instanceof NavigationEnd) {
        this.isConfirmation = event.url === '/bestellen/bestaetigung';
      }
    });

    this.checkoutService.getMe().subscribe(
      (response) => {
        this.isLoggedIn = true;
        this.sharedService.setLoggedIn(true);
      },
      (error) => {
        this.isLoggedIn = false;
        this.sharedService.setLoggedIn(false);
      }
    );
  }
}
